import React from 'react';
import ReactModal from 'react-modal';

import {
	Box,
	ButtonBase,
	IconButton,
	Typography
}
from '@mui/material';

/*
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
	root: {},
}));
*/

import BackIcon from 'icons/drawable/ic_30_back.svg';
import TextBlockIcon from 'icons/drawable/img_block_2.svg';
import ImageBlockIcon from 'icons/drawable/img_block_3.svg';
import YoutubeBlockIcon from 'icons/drawable/img_block_4.svg';

function SelectBlockTypeModal({ isOpen, onSelect, ...rest }) {
	//const classes = useStyles();

	let blockTypeInfos = [
		{
			blockType: 'text',
			displayName: '텍스트',
			desc: '텍스트를 기본으로 다양한 정보 입력이 가능한 블럭입니다',
			icon: TextBlockIcon,
			iconDesc: 'text block icon'
		},
		{
			blockType: 'image',
			displayName: '이미지',
			desc: '디자인 이미지를 넣을 수 있는 블럭입니다',
			icon: ImageBlockIcon,
			iconDesc: 'image block icon'
		},
		{
			blockType: 'youtube',
			displayName: 'YouTube',
			desc: 'YouTube 비디오를 넣을 수 있는 블럭입니다',
			icon: YoutubeBlockIcon,
			iconDesc: 'youtube block icon'
		},
		{
			blockType: 'video',
			displayName: 'Video',
			desc: 'Video 비디오를 넣을 수 있는 블럭입니다',
			icon: YoutubeBlockIcon,
			iconDesc: 'video block icon'
		},
		{
			blockType: 'pdf',
			displayName: 'PDF',
			desc: 'PDF를 넣을 수 있는 블럭입니다',
			icon: YoutubeBlockIcon,
			iconDesc: 'pdf block icon'
		},
	];

	let [blockIntroIdx, setBlockIntroIdx] = React.useState(1);

	React.useEffect(() => {
		function updateBlockIntroIdx() {
			setBlockIntroIdx(prev => {
				return (prev + 1) % blockTypeInfos.length;
			});
		}

		let timer = setInterval(updateBlockIntroIdx, 3000);

		return function cleanup() {
			clearInterval(timer);
		};

	}, [blockTypeInfos.length]);

	function getHeader() {
		return (
			<Box
				display='flex'
				flexDirection='row'
				justifyContent='flex-start'
				alignItems='center'
				sx={{
					width: '100%',
					height: `${30/360 * 100}vw`,
					marginTop: `${28/360 * 100}vw`,
					paddingLeft: `${20/360 * 100}vw`,
				}}
			>
				<ButtonBase onClick={e => onSelect()}>
					<img
						src={BackIcon}
						alt="back icon"
						style={{
							width: `${30/360 * 100}vw`,
							height: `${30/360 * 100}vw`,
							marginRight: `${10/360 * 100}vw`,
						}}
					/>
				</ButtonBase>

				<Typography
					sx={{
						fontFamily: '노토산스 Bold',
						fontSize: `${22/360 * 100}vw`,
						color: '#171717',
						letterSpacing: `${-0.1/360 * 100}vw`,
					}}
				>
					콘텐츠 블럭 추가
				</Typography>
			</Box>
		);
	}

	function getBlockIntro(idx) {
		return (
			<Box
				style={{
					display: 'flex',
					flexDirection: 'row',
					float: 'left',
					width: `${290/360 * 100}vw`,
					height: `${114/360 * 100}vw`,
					//border: '2px dotted red',
					borderTopLeftRadius: `${15/360 * 100}vw`,
					borderBottomLeftRadius: `${15/360 * 100}vw`,
					borderBottomRightRadius: `${15/360 * 100}vw`,
					boxShadow: `${2/360 * 100}vw ${2/360 * 100}vw ${18/360 * 100}vw 0 #23212331`,
					marginRight: `${20/360 * 100}vw`,
				}}
			>
				<Box
					display='flex'
					flexDirection='column'
					justifyContent='center'
					alignItems='center'
					sx={{
						width: `${90/360 * 100}vw`,
					}}
				>
					<img
						src={blockTypeInfos[idx].icon}
						alt={blockTypeInfos[idx].iconDesc}
						style={{
							width: `${40/360 * 100}vw`,
							height: `${40/360 * 100}vw`,
							marginLeft: `${24/360 * 100}vw`,
							marginRight: `${26/360 * 100}vw`,
						}}
					/>
				</Box>
				<Box
					display='flex'
					flexDirection='column'
					justifyContent='center'
					alignItems='flex-start'
					sx={{
						width: `${180/360 * 100}vw`,
					}}
				>
					<Typography
						fontFamily='노토산스 Bold'
						fontSize={`${16/360 * 100}vw`}
						color='#171717'
						letterSpacing={`${-0.62/360 * 100}vw`}
						sx={{ marginBottom:`${12/360 * 100}vw` }}
					>
						{blockTypeInfos[idx].displayName}
					</Typography>
					<Typography
						fontFamily='노토산스 Regular'
						fontSize={`${12/360 * 100}vw`}
						color='#171717'
						letterSpacing={`${-0.46/360 * 100}vw`}
					>
						{blockTypeInfos[idx].desc}
					</Typography>
				</Box>
			</Box>
		);
	}

	function getBlockIntroArea() {
		let blockIntros = [];

		for (let i = blockIntroIdx; i < blockTypeInfos.length; i++) {
			blockIntros.push(getBlockIntro(i));
		}

		if (blockIntroIdx === blockTypeInfos.length - 1) {
			// if the current block intro is the last one, put the first one to the list
			//
			blockIntros.push(getBlockIntro(0));
		}

		let dispIndicators = [];

		for (let i = 0; i < blockTypeInfos.length; i++) {
			if (i === blockIntroIdx) {
				dispIndicators.push(
					<div
						style={{
							width: `${6/360 * 100}vw`,
							height: `${6/360 * 100}vw`,
							borderRadius: `${3/360 * 100}vw`,
							marginRight: `${6/360 * 100}vw`,
							opacity: 0.2,
							backgroundColor: '#000000'
						}}
					/>
				);
			}
			else {
				dispIndicators.push(
					<div
						style={{
							width: `${16/360 * 100}vw`,
							height: `${6/360 * 100}vw`,
							borderRadius: `${3/360 * 100}vw`,
							marginRight: `${6/360 * 100}vw`,
							backgroundColor: '#6cadff'
						}}
					/>
				);
			}
		}

		return (
			<Box
				display='flex'
				flexDirection='column'
				justifyContent='center'
				alignItems='flex-start'
				sx={{
				}}
			>
				<Box
					sx={{
						width: `200vw`,
						height: `${(114 + 40)/360 * 100}vw`,
						paddingLeft: `${20/360 * 100}vw`,
						paddingTop: `${20/360 * 100}vw`,
						paddingBottom: `${20/360 * 100}vw`,
						position: 'relative',
						overflow: 'hidden',
						//border: '2px solid black',
					}}
				>
					{blockIntros}
				</Box>
				<Box
					display='flex'
					flexDirection='row'
					justifyContent='flex-start'
					alignItems='center'
					sx={{
						paddingLeft: `${23/360 * 100}vw`,
					}}
				>
					{dispIndicators}
				</Box>
			</Box>
		);
	}

	function getDivider() {
		return (
			<div
				style={{
					width: '100%',
					height: `${1/360 * 100}vw`,
					marginTop: `${40/360 * 100}vw`,
					marginBottom: `${20/360 * 100}vw`,
					backgroundColor: '#e6e6e6',
				}}
			/>
		);
	}

	function getBlockTypeIcon(info) {
		return (
			<Box
				display='flex'
				flexDirection='column'
				justifyContent='center'
				alignItems='center'
				sx={{
					marginRight: `${(70-20)/360 * 100}vw`,
					//border: '2px solid black',
				}}
			>
				<IconButton onClick={e => onSelect(info.blockType)}>
					<img
						src={info.icon}
						alt={info.iconDesc}
						style={{
							width: `${40/360 * 100}vw`,
							height: `${40/360 * 100}vw`,
						}}
					/>
				</IconButton>
				<Typography
					sx={{
						fontFamily: '노토산스 Regular',
						fontSize: `${12/360 * 100}vw`,
						color: '#171717',
						letterSpacing: `${-0.46/360 * 100}vw`,
					}}
				>
					{info.displayName}
				</Typography>
			</Box>
		);
	}

	function getBlockTypeIcons() {
		let blockTypeIcons = [];
		for (let i = 0; i < blockTypeInfos.length; i++) {
			blockTypeIcons.push(getBlockTypeIcon(blockTypeInfos[i]));
		}

		return (
			<Box
				display='flex'
				flexDirection='row'
				justifyContent='flex-start'
				alignItems='center'
				flexWrap={'wrap'}
				sx={{
					width: '100%',
					height: '100%',
					paddingLeft: `${50/360 * 100}vw`,
					marginTop: `${50/360 * 100}vw`,
					//border: '2px solid green',
				}}
			>
				{blockTypeIcons}
			</Box>
		);
	}

	return (
		<ReactModal
			isOpen={isOpen}
			ariaHideApp={false}
			preventScroll={true}
			style={{
				content: {
					position:"absolute",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					border: null,
					borderRadius: 0,
					width: '100%',
					height: '100%',
					//backgroundColor: 'white',
					padding: 0,
				}
			}}
		>
			<Box
				display="flex"
				flexDirection="column"
				justifyContent="flex-start"
				alignItems="flex-start"
				sx={{
					overflow: 'hidden',
				}}
			>
				{getHeader()}
				{/*getBlockIntroArea()*/}
				{/*getDivider()*/}
				{getBlockTypeIcons()}
			</Box>
		</ReactModal>
	);
}

export default SelectBlockTypeModal;
